export enum TrackedZones {
    CARE_HP_CARROUSEL = 'care_hp_carrousel',
}

export enum TrackedPages {
    DASHBOARD = 'accueil_dashboard',
    EC_LOGGED = 'accueil_espace_client_logue',
}

export enum TrackedNames {
    MEMBER = 'membre',
    CONTRACT = 'contrat',
    ADD_MEMBER = 'gerer_vos_profils',
    PARNASSE = 'parnasse',
    PROTECTED_HOUSE = 'maison_protegee',
    ORANGE_BUSINESS = 'obs',
    ORANGE_PRO = 'pro',
    MANAGE_ACCOUNT = 'gerer_votre_compte',
    AVANTAGES_CLIENT = 'vos_avantages_clients',
    ORANGE_SERVICES = 'vos_services_orange',
    SHARED_SERVICES = 'services_partages_nsru',
    PERSONAL_INFO = 'info_personnelles',
    PROFILS = 'gerer_vos_profiles',
    DOCUMENTS = 'documents_contractuels',
    TRACKINGDELIVERY = 'suivi_de_commande',
    CONTACT = 'demarche_et_rendez-vous',
    FACTURES = 'factures',
    OFFRE_OPTIONS = 'offre_et_options',
    LIVEBOX = 'livebox',
    TV = 'tv',
    MOBILE = 'mobile',
    SIM = 'sim',
    VOIP = 'ligne_fixe',
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    LANDLINE = 'ligne_fixe',
    FLYBOX = 'flybox',
    AIRBOX = 'airbox',
    SMARTWATCH = 'montre_connectee',
    MULTISIM = 'multi_sim',
    CYBERSECURITY = 'cybersecurite',
}
